<template>
    <b-modal id="modal-add-error-report" title="Add Error Report" modal-class="modal-w-md">
        <div class="form form-modal mb-4">
            What's the issue with the <template v-if="startupId">startup</template><template v-else>ecosystem</template>  data*
            <b-form-textarea class="form-control--mid" v-model="report.message"/>
        </div>

        <template #modal-footer>
            <b-button v-if="loading" variant="primary" disabled size="lg">Sending report...</b-button>
            <b-button v-else variant="primary" size="lg" :disabled="!canSave" @click="save">Save</b-button>
        </template>
    </b-modal>
</template>

<script>

import Vue from "vue";
import errorReportsService from "@/services/error-reports.service";

export default {
    props: {
        startupId: Number,
        ecosystemId: Number,
    },

    data() {
        return {
            report: {
                message: "",
            },

            loading: false,
        }
    },

    computed: {
        canSave() {
            return this.report.message.length
        },
    },

    methods: {

        init() {
            this.report.message = ""
        },

        open() {
            this.init()
            this.$bvModal.show('modal-add-error-report')
        },

        async save() {
            this.loading = true

            await errorReportsService.add(this.startupId, this.ecosystemId, this.report);
            this.$bvModal.hide('modal-add-error-report');
            this.loading = false;

            Vue.notify({
                group: 'app',
                type: 'success',
                duration: 5000,
                text: "Your report has been sent, thank you!"
            })
        }
    }
}
</script>
